module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAYAAAA7MK6iAAAACXBIWXMAABCcAAAQnAEmzTo0AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAADYSURBVHgB7ZXRDYMgEIYPWaDPPrUbGB2kI5TN1BEcxIRO0EdeOwH0LqGJaRrkEHziSy5q4vGFwA8AlUrlLLquuwCTmJ5mbwAp5WsYhhEi6ft+pJ49eVCstX7jY8FSMXKSCiEU9fjeY6B0wnIhOUn9PxPkJCQvJg3JU6UCmHjBA2tyzoFf03ldV8UZhy3+kUOKlGggAUdT3XxCAhKYbCIzYz2xVNu2V2PMAqX4t5FiopZdWlweE5nsck5OOfJgnL6XBL4usZEhOW76u7X2dui8LnUtViqVbHwA4Ep1/tmtQKkAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/close.png
// module id = /TeD
// module chunks = 15